import { Paper } from "@mui/material";
import styled from "styled-components";
import { theme } from "../../../../Customization/Theme";

export const CannedResponsesWrapper = styled.div`
    width: 100%;
`;

export const ResponseHeader = styled.div`
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: #fff;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    .response-header__left {
        h4 {
            font-size: 1rem;
            font-weight: 500;
        }
    }
    .response-header__right {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`

export const MessageContainer = styled(Paper)`
    // width: 100%;
    height: calc(100% - (60px + 52px));
    margin-left: 1rem;
    margin-right: 1rem;
`

export const MessagesTable = styled.div`
    height: 100%;
    .table-header {
        display: flex;
        padding: 1rem;
        border-bottom: 1px solid ${theme.palette.default.grey};

        .heading-text {
            display: flex;
            align-items: center;

            h4 {
            font-size: 0.875rem;
            font-weight: 500;
            }
        }

        .heading-text:first-child {
            min-width: 280px;
        }

        .heading-text:nth-child(2) {
            flex-grow: 1;
        }

        .heading-text:last-child {
            min-width: 120px;
            justify-content: flex-end;
        }
        }


    .table-data {
        height: calc(100% - 54px);
        overflow: auto;
    }

    .table-row__content {
        border-bottom:1px solid rgba(203, 205, 211, 0.3);;
    }

    .table-content {
        display: flex;
        padding: 1rem;
        .table-content__text {
            display: flex;
            align-items: center;
             h4 {
                font-weight: 500;
                font-size: 0.875rem;
            }
            p {
                 font-size: 0.875rem;
                color: ${theme.palette.default.darkGrey};
             }
            .table-actions {

            }
            
        }
    }
    
    .table-content > :first-child {
        min-width: 280px;
        }

        .table-content > :nth-child(2) {
        flex-grow: 1;
        width: auto;
        }

        .table-content > :last-child {
        min-width: 120px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        }
`

export const AddCannedResponse = styled.div`
    .header {
        padding: 1rem 1.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom:1px solid rgba(203, 205, 211, 0.3);
        h4 {
            font-size: 1.1rem;
                font-weight: 500;
        }
    }
    .body {
        padding: 1.1rem;
        textarea {
            height: 180px;
        }
    }

    .footer {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }
`

export const DeleteCannedResponse = styled.div`
    .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0.875rem;
        border-bottom:1px solid rgba(203, 205, 211, 0.3);
        .header-left {
            display: flex;
            gap: 0.875rem;
            .danger {
                padding-top: 4px;
                img {
                    width: 1.2rem;
                }
            }
            .text h4 {
                font-size: 1.1rem;
                font-weight: 500;
            }
            .text p {
                color: ${theme.palette.default.darkGrey};
            }
        }
        .header-right {
            .MuiSvgIcon-root {
                color: ${theme.palette.default.darkGrey};
            }
            cursor: pointer;
        }
    }

    .footer {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        padding: 0.875rem;
    }
`